import { bootNav } from "./boot";

(() => {
  if (typeof window === "undefined" || typeof navigator === "undefined" || typeof document === "undefined") {
    return;
  }

  const ua = (navigator.userAgent || "").toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isAndroidWebView = ua.includes("wv");
  const nav = navigator as Navigator & { standalone?: boolean };
  const isIOSWebView = isIOS && !ua.includes("safari") && nav.standalone !== true;
  const isWebView = isAndroidWebView || isIOSWebView;
  const normalizePath = (path: string) => {
    const lower = path.toLowerCase();
    return lower.length > 1 ? lower.replace(/\/+$/, "") : lower;
  };
  const path = normalizePath(window.location.pathname || "");
  const hash = (window.location.hash || "").toLowerCase();
  const hideHeaderPaths = ["/terms", "/privacy-policy", "/privacy", "/privacypolicy"];
  const shouldHideHeader = hideHeaderPaths.includes(path) || hash.includes("privacypolicy");

  if (isWebView && document.head) {
    const style = document.createElement("style");
    style.textContent = `.hide_in_app { display: none !important; }${
      shouldHideHeader ? " #header, #header-new { display: none !important; }" : ""
    }`;
    document.head.appendChild(style);
  }
})();

window.addEventListener("DOMContentLoaded", () => {
  bootNav(window, document);
});
